module.exports = __webpack_public_path__ + "img/p-one-step-24.13115777.png";